(() => {
  if (customElements.get('trust-stats-slider')) return;

  class TrustStatsSlider extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.onSectionLoad = this.onSectionLoad.bind(this);
      this.onSectionUnload = this.onSectionUnload.bind(this);
    }

    connectedCallback() {
      this.initSwiper();
      this.addEventListener('shopify:section:load', this.onSectionLoad);
      this.addEventListener('shopify:section:unload', this.onSectionUnload);
    }

    disconnectedCallback() {
      this.destroySwiper();
      this.removeEventListener('shopify:section:load', this.onSectionLoad);
      this.removeEventListener('shopify:section:unload', this.onSectionUnload);
    }

    onSectionLoad() {
      this.destroySwiper();
      this.initSwiper();
    }

    onSectionUnload() {
      this.destroySwiper();
    }

    initSwiper() {
      const swiperEl = this.querySelector('.trust-stats-slider__swiper');
      if (!swiperEl || typeof Swiper === 'undefined') return;

      this.swiper = new Swiper(swiperEl, {
        slidesPerView: 1.11,
        spaceBetween: 12,
        slidesOffsetAfter: 20,
        breakpoints: {
          500: {
            slidesPerView: 1.5,
            spaceBetween: 12,
            slidesOffsetAfter: 20,
          },
          650: {
            slidesPerView: 1.8,
            spaceBetween: 12,
            slidesOffsetAfter: 20,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
            slidesOffsetAfter: 0
          },
          1024: {
            slidesPerView: 2,
            spaceBetween: 28,
            slidesOffsetAfter: 0
          }
        }
      });
    }

    destroySwiper() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }

  customElements.define('trust-stats-slider', TrustStatsSlider);
})();
